//Bitwise enum flags (powers of two)
exports.decoratorOptions = {
    react: 1,
    reactDom: 2
};